import {
  compareCacheSlot,
  type FilterKey,
  type UniverseFilter,
  type WindowKey,
} from '@meridian/contracts';

import { ROOT_KEY } from './root';

/**
 * Dashboard query keys. `asOf` is first after the feature segment so a changed
 * `/v1/meta` asOf invalidates every dashboard entry in the same tick (plan §6.6 /
 * Phase 5).
 */
export const dashboardKeys = {
  all: [...ROOT_KEY, 'dashboard'] as const,
  /* `book` and `compare` are part of the key, not an afterthought: a filtered
     and an unfiltered dashboard are DIFFERENT payloads with different breadth
     and sector aggregates, and sharing a cache slot would show one under the
     other's heading. `?? null` so the off state occupies one stable slot. */
  detail: (asOf: string | null, window: WindowKey, index: FilterKey, filters?: UniverseFilter) =>
    [
      ...dashboardKeys.all,
      asOf,
      window,
      index,
      filters?.book ?? null,
      compareCacheSlot(filters?.compare),
    ] as const,
  snapshot: (asOf: string | null) => [...dashboardKeys.all, 'snapshot', asOf] as const,
  /* SPY window series (issue #82). Segmented like snapshot so it never
     collides with dashboardKeys.detail. Window is part of the key: 1Y and
     3Y are different calendars, not two views of one payload. */
  benchmarkSeries: (asOf: string | null, window: WindowKey) =>
    [...dashboardKeys.all, 'benchmark', asOf, window] as const,
  /* The book itself is independent of asOf/window/index — one slot per session. */
  book: () => [...dashboardKeys.all, 'book'] as const,
};
